<template>
    <div class="intelligence-kpis">
        <div v-for="card in cards" :key="card.key" class="intelligence-kpis__card">
            <p class="intelligence-kpis__label">{{ card.label }}</p>
            <p class="intelligence-kpis__value">{{ card.displayValue }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            totals: {
                type: Object,
                default: () => ({}),
            },
        },

        computed: {
            cards() {
                const totals = this.totals || {}

                return [
                    {
                        key: 'demandCount',
                        label: this.$t('pages.intelligence.supply_demand.kpis.demand'),
                        displayValue: this.formatCount(totals.demandCount),
                    },
                    {
                        key: 'supplyProviderCount',
                        label: this.$t('pages.intelligence.supply_demand.kpis.supply'),
                        displayValue: this.formatCount(totals.supplyProviderCount),
                    },
                    {
                        key: 'specialitiesWithDemand',
                        label: this.$t('pages.intelligence.supply_demand.kpis.specialties_with_demand'),
                        displayValue: this.formatCount(totals.specialitiesWithDemand),
                    },
                    {
                        key: 'specialitiesWithZeroSupply',
                        label: this.$t('pages.intelligence.supply_demand.kpis.zero_supply'),
                        displayValue: this.formatCount(totals.specialitiesWithZeroSupply),
                    },
                ]
            },
        },

        methods: {
            formatCount(value) {
                if (value === null || value === undefined) return '—'
                return value
            },
        },
    }
</script>

<style lang="scss" scoped>
    .intelligence-kpis {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
        gap: 16px;
    }

    .intelligence-kpis__card {
        background: #fff;
        border: 1px solid #e5e7eb;
        border-radius: 12px;
        padding: 20px;
    }

    .intelligence-kpis__label {
        margin: 0 0 8px;
        font-size: 13px;
        color: #6b7280;
    }

    .intelligence-kpis__value {
        margin: 0;
        font-size: 28px;
        font-weight: 700;
        color: #111827;
    }
</style>
